var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsInt, IsOptional, IsString, IsUUID, MaxLength, Min } from 'class-validator';
export class CreateTreatmentUnitInputDto {
    billableServiceItemId;
    sequenceInPlan;
    /**
     * Natural-key back-reference to the plan's prescribed Heilmittelkatalog option
     * (#1425 slice 1): the `optionName` of the entry in
     * `prescriptionData.prescribedCatalogOptions` this unit was prescribed under.
     * The command resolves it to the created option's id. Absent for non-GKV
     * plans and for a GKV capture made without a Diagnosegruppe.
     */
    prescribedCatalogOptionName;
    /**
     * Declares that `billableServiceItemId` above is a **system-derived scheduling
     * anchor**, because the prescribed Katalog option names no Positionsnummer — a
     * bare `MLD` (#1428 slice 2). It carries the same id; sending it records that
     * no human chose the item, and that it is not an assertion about what will be
     * billed. Omitted for every option that names a Positionsnummer of its own.
     */
    schedulingAnchorBillableServiceItemId;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], CreateTreatmentUnitInputDto.prototype, "billableServiceItemId", void 0);
__decorate([
    Expose(),
    IsInt(),
    Min(1),
    __metadata("design:type", Number)
], CreateTreatmentUnitInputDto.prototype, "sequenceInPlan", void 0);
__decorate([
    Expose(),
    IsString(),
    MaxLength(255),
    IsOptional(),
    __metadata("design:type", String)
], CreateTreatmentUnitInputDto.prototype, "prescribedCatalogOptionName", void 0);
__decorate([
    Expose(),
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateTreatmentUnitInputDto.prototype, "schedulingAnchorBillableServiceItemId", void 0);
export class TreatmentUnitDto {
    id;
    createdAt;
    updatedAt;
    billableServiceItemId;
    sequenceInPlan;
    status;
}
//# sourceMappingURL=treatment-unit.dto.js.map